import { Button, Form, Input, Radio, Space } from "antd";
import { PlusCircle, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Question } from "@types";
import { useEffect, useState } from "react";

interface Props {
  question?: Question;
}

export const SingleChoiceQuestion = ({question}: Props) => {
  const {t} = useTranslation();
  const form = Form.useFormInstance();
  const [defaultCorrectAnswerIndex, setDefaultCorrectAnswerIndex] = useState<any>(0);

  useEffect(() => {
    if (question && question.answers) {
      const correctAnswerIndex = question.answers.findIndex(answer => answer.isCorrect);
      setDefaultCorrectAnswerIndex(
        correctAnswerIndex >= 0 ? correctAnswerIndex : undefined
      );
    }
  }, [JSON.stringify(question?.answers || [])]);

  useEffect(() => {
    if (defaultCorrectAnswerIndex === undefined) return;
    const currentAnswers = form.getFieldValue(["answers"]) || question?.answers || [];
    if (!currentAnswers || !Array.isArray(currentAnswers)) return;
    const updatedAnswers = currentAnswers.map((answer: any, idx: number) => ({
      ...answer,
      isCorrect: idx === defaultCorrectAnswerIndex,
    }));
    form.setFieldValue(["answers"], updatedAnswers);
  }, [defaultCorrectAnswerIndex]);

  return (
    <>
      <Form.List name={["answers"]} initialValue={question?.answers || [{}]}>
        {(fields, { add, remove }) => (
          <Radio.Group
            style={{ width: "100%" }}
            value={defaultCorrectAnswerIndex}
            onChange={(e) => {
              const selectedIndex = e.target.value;
              setDefaultCorrectAnswerIndex(selectedIndex);
              const currentAnswers = form.getFieldValue(["answers"]) || [];
              const updatedAnswers = (currentAnswers || []).map((answer: any, idx: number) => ({
                ...answer,
                isCorrect: idx === selectedIndex,
              }));
              form.setFieldValue(["answers"], updatedAnswers);
            }}
          >
            {fields.map(({ key, name, ...restField }, index) => {
              return (
                <Space
                  className="question-type-form"
                  key={key}
                  style={{ display: "flex", marginBottom: 8 }}
                  align="baseline"
                >
                  <Radio value={index} />

                  <Form.Item
                    style={{ width: "100%" }}
                    key={`${key}-value-${name}`}
                    {...restField}
                    name={[name, "value"]}
                    rules={[
                      { required: true, message: t("forms.questions.inputPlaceholder") },
                    ]}
                  >
                    <Input placeholder={t("forms.questions.inputPlaceholder")} />
                  </Form.Item>
                  <Button
                    icon={<Trash2 />}
                    danger
                    onClick={() => remove(name)}
                  />
                </Space>
              );
            })}
            <Form.Item noStyle>
              <Button
                type="dashed"
                icon={<PlusCircle />}
                block
                onClick={() => add()}
              >
                {t("forms.questions.addAnswer")}
              </Button>
            </Form.Item>
          </Radio.Group>
        )}
      </Form.List>
    </>
  );
};
